<div class="mb-0 px-3">
  <h5 class="fw-bold headings-primary mb-0">
    Welcome Back, {{ full_name }}
  </h5>

  <p class="text-muted text-xxs">
    Here's your Alt Capital portfolio summary.
  </p>
</div>